export const getInvoicesTypes = {
  REQUEST: 'GET_INVOICES_REQUEST',
  SUCCESS: 'GET_INVOICES_SUCCESS',
  FAILED: 'GET_INVOICES_FAILED'
};

export const getAssociatedInvoicesTypes = {
  REQUEST: 'GET_INVOICES_FROM_PROVIDER_REQUEST',
  SUCCESS: 'GET_INVOICES_FROM_PROVIDER_SUCCESS',
  FAILED: 'GET_INVOICES_FROM_PROVIDER_FAILED'
};

export const getAccountInvoicesTypes = {
  REQUEST: 'GET_ACCOUNT_INVOICES_REQUEST',
  SUCCESS: 'GET_ACCOUNT_INVOICES_SUCCESS',
  FAILED: 'GET_ACCOUNT_INVOICES_FAILED'
};

export const getRequestedInvoicesTypes = {
  REQUEST: 'GET_REQUESTED_INVOICES_REQUEST',
  SUCCESS: 'GET_REQUESTED_INVOICES_SUCCESS',
  FAILED: 'GET_REQUESTED_INVOICES_FAILED'
};
export const getUnassociatedInvoices = {
  REQUEST: 'GET_REQUESTED_UNASSOCIATED_INVOICES_REQUEST',
  SUCCESS: 'GET_REQUESTED_UNASSOCIATED_INVOICES_SUCCESS',
  FAILED: 'GET_REQUESTED_UNASSOCIATED_INVOICES_FAILED'
};
export const sortInvoicesTypes = {
  SORT_REQUESTED: 'SORT_REQUESTED_INVOICES_REQUEST',
  SORT_ASSOCIATED: 'SORT_ASSOCIATED_INVOICES_REQUEST',
  SORT_ELECTRONIC: 'SORT_ELECTRONIC_INVOICES_REQUEST',
  SORT_ACCOUNT: 'SORT_ACCOUNT_INVOICES_REQUEST'
};

export const electronicInvoicesTypes = {
  DELETE_E_REQUEST: 'DELETE_ELECTRONIC_INVOICE_REQUEST'
};

export const getNotifTypes = {
  REQUEST: 'GET_NOTIFICATIONS_REQUEST',
  SUCCESS: 'GET_NOTIFICATIONS_SUCCESS',
  FAILED: 'GET_NOTIFICATIONS_FAILED'
};

export const updateNotifTypes = {
  REQUEST: 'UPDATE_NOTIFICATION_REQUEST',
  SUCCESS: 'UPDATE_NOTIFICATION_SUCCESS'
};

export const updateAllNotifTypes = {
  REQUEST: 'UPDATE_ALL_NOTIFICATION_REQUEST'
};

export const getReceiptDocumentTypes = {
  REQUEST: 'GET_RECEIPT_DOCUMENT_REQUEST',
  FINISH: 'GET_RECEIPT_DOCUMENT_FINISH'
};

export const deleteInvoicesTypes = {
  DELETE_REQUEST: 'DELETE_INVOICES_REQUEST',
  DELETE_SUCCESS: 'DELETE_INVOICES_SUCCESS',
  DELETE_FAILED: 'DELETE_INVOICES_FAILED'
};